import { useRedirectRevokedEventCreation } from '@hooks/use-redirect-revoked-event-creation/use-redirect-revoked-event-creation';

import type { EventCreationGuardProps } from './event-creation-guard.type';

export const EventCreationGuard = ({ children }: EventCreationGuardProps) => {
  const isEventCreationBlocked = useRedirectRevokedEventCreation();

  return isEventCreationBlocked ? null : children;
};
